import { makeApi } from "@zodios/core";
import { z } from "zod";

import { createPasswordBody, resetPasswordBody } from "@/data/api/kili/password-recovery/password-recovery.type";

export const passwordRecoveryApi = makeApi([
  {
    method: "post",
    path: "/create-code-for-email/:email",
    response: z.unknown(), // 200 ok
    alias: "sendPasswordRecoveryEmail",
    parameters: [
      {
        type: "Path",
        name: "email",
        schema: z.string(),
      },
    ],
  },
  {
    method: "post",
    path: "/update-password-for-email/:email",
    response: z.unknown(), // 200 ok
    alias: "resetPassword",
    parameters: [
      {
        type: "Path",
        name: "email",
        schema: z.string(),
      },
      {
        type: "Body",
        name: "body",
        schema: resetPasswordBody,
      },
    ],
  },
  {
    method: "post",
    path: "/create-password-for-email/:email",
    response: z.unknown(), // 200 ok
    alias: "createPassword",
    parameters: [
      {
        type: "Path",
        name: "email",
        schema: z.string(),
      },
      {
        type: "Body",
        name: "body",
        schema: createPasswordBody,
      },
    ],
  },
]);
